import { render, staticRenderFns } from "./insertReceive.vue?vue&type=template&id=371beff0&"
import script from "./insertReceive.vue?vue&type=script&lang=js&"
export * from "./insertReceive.vue?vue&type=script&lang=js&"
import style0 from "./insertReceive.vue?vue&type=style&index=0&id=371beff0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports